import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

type Props = {
  width?: number;
  align?: 'left' | 'right';
};
export default styled(TableCell)(({ width = 56, align = 'right' }: Props) => ({
  width: `${width}px`,
  paddingLeft: '8px',
  paddingRight: '8px',
  textAlign: align
}));
